import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Detect browser language
function detectBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage;
  if (browserLang.toLowerCase().startsWith('es')) {
    return 'es';
  }
  return 'ru';
}

export default function LanguageRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    // Check localStorage first
    const savedLang = localStorage.getItem('language');
    if (savedLang && ['ru', 'es'].includes(savedLang)) {
      navigate(`/${savedLang}`, { replace: true });
      return;
    }

    // Use browser language
    const browserLang = detectBrowserLanguage();
    navigate(`/${browserLang}`, { replace: true });
  }, [navigate]);

  return null; // This component just redirects, no UI
}
